<div class="p-3">
    <h3 class="my-3 text-primary fw-bold">Add Lucky Draw</h3>
    <button (click)="add()" class="btn btn-primary btn-sm w-100">Add Lucky Draw</button>
    <table class="table table-stripted">
        <thead>
            <tr><th>No</th><th>Winning</th><th></th></tr>
        </thead>
        <tbody>
            <tr *ngFor="let draw of draws; let i = index">
                <th>{{i + 1}}</th>
                <th>
                    <select class="form-control form-control-sm" name="winning" #winning="ngModel" [(ngModel)]="draw.winning" required>
                        <option [value]="section.value" *ngFor="let section of sections">{{section.label}}</option>
                    </select>
                </th>
                <td><button class="btn btn-sm btn-danger" (click)="remove(i)">Delete</button></td>
            </tr>
        </tbody>
    </table>
    <button (click)="save()" class="btn btn-success btn-sm w-100">SAVE</button>
    <h3 class="my-3 text-primary fw-bold">Voucher History</h3>
    <table class="table table-stripted">
        <thead>
            <tr><th>No</th><th>Winning</th><th>Used</th></tr>
        </thead>
        <tbody>
            <tr *ngFor="let voucher of vouchers; let i = index">
                <td>{{i + 1}}</td>
                <td>{{voucher.winning}}</td>
                <td>{{voucher.used_on | date: 'short'}}</td>
            </tr>
        </tbody>
    </table>
</div>